import { SubjectRole } from "../../../generated/graphql"

/*
 * Check user role for access select custom from range for iwp details chart
 */
const canRoleFetchCustomRangeForIwp = (role: SubjectRole) => {
    return [
        SubjectRole.PpoAdmin,
        SubjectRole.OrgAdmin,
        SubjectRole.OrgMember,
    ].includes(role)
}

/*
 * Check user role access to update well attributes
 * https://petropower.atlassian.net/wiki/spaces/TREX/pages/2798649345/Current+Role+Structure#Users-and-Roles
 */
const canRoleUpdateWellAttributes = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin, SubjectRole.OrgAdmin].includes(role)
}

/**
 * Check user role access to update well wiring mode.
 * Access is intentionally restricted to PPO admin only.
 */
const canRoleUpdateWellWiringMode = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin].includes(role)
}

/**
 * Only PPO Admin  has access to use smart setting over ride values
 * */
const canRoleUseSmartSettingOverride = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin].includes(role)
}

const canRoleAddOrganization = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin].includes(role)
}

const canRoleUpdateOrganization = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin].includes(role)
}

const canRoleFetchInactiveUsers = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin].includes(role)
}

const canRoleAddAlertRule = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin, SubjectRole.OrgAdmin].includes(role)
}

/**
 * Only Org Admin & PPO Admin have access to see User Admin page
 */

const canRoleAccessUserAdminPage = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin, SubjectRole.OrgAdmin].includes(role)
}

/**
 * Only PPO Admin has access to see Org Admin page
 */

const canRoleAccessOrgAdminPage = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin].includes(role)
}

/**
 * Org Admin or higher can add, update subscriptions, delete subscriptions for other users.
 */
const canRoleAdminSubscriptions = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin, SubjectRole.OrgAdmin].includes(role)
}

/**
 * Only PPO Admin can mark well notes as INTERNAL or flip visibility.
 */
const canRoleManageInternalWellNotes = (role: SubjectRole) => {
    return [SubjectRole.PpoAdmin].includes(role)
}

export {
    canRoleFetchCustomRangeForIwp,
    canRoleUpdateWellAttributes,
    canRoleUpdateWellWiringMode,
    canRoleUseSmartSettingOverride,
    canRoleAddOrganization,
    canRoleUpdateOrganization,
    canRoleFetchInactiveUsers,
    canRoleAddAlertRule,
    canRoleAccessUserAdminPage,
    canRoleAccessOrgAdminPage,
    canRoleAdminSubscriptions,
    canRoleManageInternalWellNotes,
}
